import { lazy, LazyExoticComponent, Suspense } from "react";

import { Brand } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

const DefaultForgottenPassword = lazy(() => import("./default"));
const VIDForgottenPassword = lazy(() => import("./vid"));

const PAGES_BY_BRAND: Record<Brand, LazyExoticComponent<() => JSX.Element>> = {
  default: DefaultForgottenPassword,
  vid: VIDForgottenPassword,
  dtw: DefaultForgottenPassword,
  aov: DefaultForgottenPassword,
  cen: DefaultForgottenPassword,
};

function RootForgottenPassword() {
  const { brand } = useTypedSelector((state) => state.environment);

  const PageByBrand = PAGES_BY_BRAND[brand] ?? DefaultForgottenPassword;

  return (
    <Suspense
      fallback={
        <LoadingContainer isLoading>
          <></>
        </LoadingContainer>
      }>
      <PageByBrand />
    </Suspense>
  );
}

export default RootForgottenPassword;
